import React from 'react';
import { SidebarContainer, SidebarLi ,Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLink, SidebarBtnWarp, SidebarRoute } from './SidebarElements';
const Sidebar = ({isOpen, toggle}) => {
    return (
        <>
            <SidebarContainer isOpen={ isOpen } onClick={ toggle } >
                <Icon onClick={toggle}>
                    <CloseIcon/>
                </Icon>
                <SidebarWrapper>
                    <SidebarMenu>
                       <SidebarLi>
                            <SidebarLink to="Acerca_Jimmy" onClick={ toggle }>
                              Acerca del Jimmy
                            </SidebarLink>
                       </SidebarLi>
                       <SidebarLi>
                            <SidebarLink to="Habilities" onClick={ toggle }>
                              Habilidades
                            </SidebarLink>
                        </SidebarLi>
                       <SidebarLi>
                        <SidebarLink to="Portafolio" onClick={ toggle }>
                           Portafolio
                        </SidebarLink>
                        </SidebarLi>
                    </SidebarMenu>
                    <SidebarBtnWarp>
                        <SidebarRoute to="/Experiencie">
                            Saber más del Jimmy
                        </SidebarRoute>
                    </SidebarBtnWarp>
                </SidebarWrapper>
            </SidebarContainer>
        </>
    )
}

export default Sidebar
